import React from 'react';
import MaintainanceComponent from './under-maintainance.component';

function Maintainance() {
    return <MaintainanceComponent />;
}

export default Maintainance;
